'use strict';

/* jshint -W098 */
angular.module('mean.projects').controller('ProjectAdminEditController', ['$scope', 'Global', 'Projects', 'ProjectBids', 'MeanUser', 'Users', '$filter', '$http', 'Holidays', '$timeout', 'ProjectTasks', 'ProjectJobs', 'Bids', 'Builders', 'Materials', 'Equipments', 'tradeCodeService', '$rootScope', '$q', 'userService', 'builderService', 'Trades', 'contactService',
  function($scope, Global, Projects, ProjectBids, MeanUser, Users, $filter, $http, Holidays, $timeout, ProjectTasks, ProjectJobs, Bids, Builders, Materials, Equipments, tradeCodeService, $rootScope, $q, userService, builderService, Trades, contactService) {
    $scope.global = Global;
    $scope.package = {
      name: 'projectAdmin'
    };

    $scope.options = {};

    $scope.options.zoom = 1;
    $scope.options.layout = 'Task';

    $scope.headersFormats = {
        'year': 'YYYY', 
        'quarter': '[Q]Q YYYY', 
        month: 'MMMM YYYY', 
        week: 'w',
        day: 'DDD', 
        hour: 'H', 
        minute:'HH:mm'
    }

    $scope.customtask = {
        name: "Some task",
        classes: "custom-task"
    }

    $scope.tradeFilter = '';
    $scope.sortType = ['phase', 'number*1'];
    $scope.sortReverse = false;

    $scope.user = MeanUser.user;

    var holidays = [];
    var dateFormat = 'yyyy-MM-dd';
    $scope.date_array = [];

    // Holidays.query({}, function(holiday_array) {
    //     holiday_array.forEach(function(hol) {
    //         holidays.push($filter('date')(hol.date, dateFormat));
    //     });
    // });

    userService.getMainAccount($scope.user.username).then(function(account) {
        $scope.main_user_account = account;

        Holidays.query({'main_account_id': account._id}, function(holiday_db) {
            if(holiday_db.length === 1)
              holidays = holiday_db[0].entries;
        });
    });

    $scope.lot_numbers = [];

    for(var i=1; i<1000; i++) {
        if(i < 10) {
            $scope.lot_numbers.push('00' + i);
        } else if(i < 100){
            $scope.lot_numbers.push('0' + i);
        } else {
            $scope.lot_numbers.push(i);
        }
    };

    $scope.phase_numbers = [];

    for(var i=0; i<100; i++) {
        if(i < 10) {
            $scope.phase_numbers.push('0' + i);
        } else {
            $scope.phase_numbers.push(i);
        }
    };

    $scope.group_options = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
    'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    $scope.eEditable = -1;
    $scope.editId = 0;

    $scope.projects = [];
    $scope.project_admin_menu = [];
    $scope.current_menu = {};
    $scope.selectedItem = {};
    $scope.plan_menu = [];
    $scope.current_plan = {};
    $scope.tasks = []; //holds array of tasks with bid information
    $scope.bid_tasks = []; //bids by project
    $scope.my_roles = [];
    $scope.is_admin = false;
    $scope.is_contractor = false;
    $scope.is_division = false;
    $scope.is_manager = false;

    $scope.user = MeanUser.user;
    $scope.my_roles = MeanUser.user.roles;

    $scope.is_admin = userService.isAdmin($scope.user);
    $scope.is_builder = builderService.isBuilder($scope.user.username);

    if($scope.is_builder)
      $scope.can_edit = true;
    else
      $scope.can_edit = false;

    $scope.is_manager = ($scope.user.roles.indexOf('tm') !== -1);

    $scope.data = [];
    var now = new Date();

    $scope.first_day = moment([now.getFullYear(), 0, 1]);
    $scope.current_day = moment([now.getFullYear(), 0, 1]);
    $scope.days_offset = 0;

    $scope.minDate = new Date();
    $scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 0,
        showWeeks: false
    };

    // Disable weekend selection
    $scope.disabled = function(date, mode) {
        if(mode === 'day') {
            if(holidays.indexOf($filter('date')(date, dateFormat)) !== -1) {
                return 1;
            } 
        }
        return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
    };

    $scope.init = function() {
        Users.query({'trade': $scope.user.trade[0], 'contractor_code': $scope.user.contractor_code}, function(users) {
            $scope.tm_users = $filter('filter')(users, { roles: 'tm' }, true);
        });

        if($scope.is_builder) {
            userService.getMainAccountId($scope.user.username).then(function(id) {
                Builders.query({'builder': id}, function(builders) {
                    $scope.builders = builders;
                    $scope.selectedBuilder = builders[0];

                    Projects.query({'trade_code': userService.getTradeCode(MeanUser.user.username), 
                    'company_code': userService.getCompanyCode(MeanUser.user.username)}, function(projects) {
                        $scope.projects = projects;
                    });
                });
            });
        } else {
            userService.getMainAccountId($scope.user.username).then(function(id) {
                contactService.getMyContacts(id).then(function(contacts) {
                    $scope.builders = [];

                    Trades.query({'main_account_id': id}, function(trade) {
                        $scope.companyFactors = trade[0].costs;
                        $scope.builders.push(trade[0]);
                    });

                    contacts.builders.forEach(function(builder) {
                        Builders.query({'builder': builder._id}, function(builders) {
                            $scope.builders.push(builders[0]);
                        });
                    });
                });
            });
        }

        $scope.project_admin_menu.push({
            item: 'Lots Information'
        });
        $scope.project_admin_menu.push({
            item: 'Project Information'
        });
        $scope.project_admin_menu.push({
            item: 'Trades Information'
        });
        $scope.project_admin_menu.push({
            item: 'Schedule'
        });
        $scope.project_admin_menu.push({
            item: 'Task List'
        });
        $scope.project_admin_menu.push({
            item: 'Template Task Chart'
        });
        $scope.project_admin_menu.push({
            item: 'Color Scheme'
        });
        $scope.project_admin_menu.push({
            item: 'Documents'
        });
         $scope.project_admin_menu.push({
            item: 'Options'
        });

        $scope.current_menu = $scope.project_admin_menu[0];
    };
        

    $scope.changeBuilder = function(builder) {
        $scope.projects = [];

        if($scope.is_admin && !$scope.is_builder && this.selectedBuilder.trade) {
            $scope.can_edit = true;
        } else {
            $scope.can_edit = false;
        }

        if($scope.is_admin && $scope.is_builder) {
            //I want to see all the projects
            Projects.query({'builder.name': this.selectedBuilder.name}, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;
            });
        } else if($scope.is_admin && !$scope.is_builder) {
            //I want to see all of my contracted projects
            Projects.query({'builder.name': this.selectedBuilder.name, 
                'trades.main_username': $scope.main_user_account.username}, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;
            });
        } else if($scope.is_division) {
            //I want to see all of my contracted projects
            Projects.query({'builder.name': this.selectedBuilder.name, 'mtc.division_manager_name': MeanUser.user.name}, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;
            });
        } else if($scope.is_manager) {
            Projects.query({'builder.name': this.selectedBuilder.name, 'trades.manager.username': MeanUser.user.username}, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;
            });
        } else if($scope.is_foreman) {
            Projects.query({'builder.name': this.selectedBuilder.name}, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;
            });
        }
    };

    $scope.updateGantt = function(ordered_tasks) {
        $scope.data = [];

        ordered_tasks.forEach(function(task) {
            if($scope.tradeFilter !== '' && task.trade !== $scope.tradeFilter) {
                console.log('does not match the trade filter');
                return;
            } 

            var tmp_task = $filter('filter')($scope.selectedItem.trades, {name: $scope.getTradeString(task.trade)});

            if($scope.options.layout === 'Trade') {
                var trade = $filter('filter')($scope.data, {name: $scope.getTradeString(task.trade)});

                if(trade.length > 1) {
                    alert('Problem with the trade list');
                }
            }

            var end_date = moment($scope.first_day);
            var start_date = moment($scope.first_day);
            var color_option = {};

            start_date.add(task.days_offset, 'days');
            end_date.add(task.days_offset + task.days -1, 'days');

            if(tmp_task.length === 0) {
                color_option = '#9FC5F8';
            } else {
                color_option = '#93C47D';
            }

            if($scope.options.layout === 'Trade') {
                if(trade.length === 0) {
                    $scope.data.push({
                        name: $scope.getTradeString(task.trade),
                        tasks: [{
                            name: task.trade + task.task + ': ' + task.name,
                            data: {
                                id: task._id,
                                order: task.order,
                                trade: task.trade,
                                task: task.task
                            },
                            color: color_option,
                            from: new Date(start_date.year(), start_date.month(), start_date.date(), 0, 0, 0),
                            to: new Date(end_date.year(), end_date.month(), end_date.date(), 24, 0, 0)
                        }]
                    });
                } else {
                    trade[0].tasks.push({
                        name: task.trade + task.task + ': ' + task.name,
                        data: {
                            id: task._id,
                            order: task.order,
                            trade: task.trade,
                            task: task.task
                        },
                        color: color_option,
                        from: new Date(start_date.year(), start_date.month(), start_date.date(), 0, 0, 0),
                        to: new Date(end_date.year(), end_date.month(), end_date.date(), 24, 0, 0)
                    });
                }
            } else {
                //organize gantt chart by task
                $scope.data.push({
                    name: task.trade + task.task + ': ' + task.name,
                    trade: $scope.getTradeString(task.trade),
                    tasks: [{
                        name: task.trade + task.task + ': ' + task.name,
                        data: {
                            id: task._id,
                            order: task.order,
                            trade: task.trade,
                            task: task.task
                        },
                        color: color_option,
                        from: new Date(start_date.year(), start_date.month(), start_date.date(), 0, 0, 0),
                        to: new Date(end_date.year(), end_date.month(), end_date.date(), 24, 0, 0)
                    }]
                });
            }
        });
    };

    $scope.filterData = function() {
        //console.log('in filterData');
        var ordered_tasks = $filter('orderBy')($scope.selectedItem.plan[0].task_list, 'order', false);
        $scope.updateGantt(ordered_tasks);
    };

    $scope.changeLayout = function() {
        var ordered_tasks = $filter('orderBy')($scope.selectedItem.plan[0].task_list, 'order', false);
        $scope.updateGantt(ordered_tasks);
    };

    $scope.changeProject = function(proj) {
        if(!this.selectedItem) {
            console.log('selectedItem is null...returning.');
            return;
        }

        $scope.selectedItem = this.selectedItem;

        $rootScope.$broadcast("projectSelectionUpdated", { selectedItem: $scope.selectedItem });
        

        if($scope.current_menu.item === 'Schedule') {
            var ordered_tasks = $filter('orderBy')($scope.selectedItem.plan[0].task_list, 'order', false);
            $scope.updateGantt(ordered_tasks);
        }

        ProjectBids.query({'project_id':$scope.selectedItem._id, 'latest': true}, function(tasks) {
            $scope.bid_tasks = tasks;

            $scope.plan_menu = [];

            $scope.plan_menu.push({
                item: 'Standard'
            });
            $scope.selectedItem.plan_codes.forEach(function(plan){
                $scope.plan_menu.push(plan);
            });
            $scope.current_plan = $scope.plan_menu[0];
            $scope.onPlanSelect($scope.current_plan);
        });
    };

    $scope.onSelect = function(item) {
        $scope.current_menu = item;

        if(item.item === 'Schedule') {
            var ordered_tasks = $filter('orderBy')($scope.selectedItem.plan[0].task_list, 'order', false);
            $scope.updateGantt(ordered_tasks);
        } else if(item.item === 'Task List') {
            $scope.onPlanSelect($scope.current_plan);
        }
    };

    $scope.editTradeInfo = function(item) {
        $scope.available_managers = [];
        //$scope.available_material_suppliers = [];
        //$scope.available_equipment_suppliers = [];

        $scope.current_selected_trade = item.name;
        //$scope.current_selected_material = item.supplier;
        //$scope.current_selected_equipment = item.equipment_supplier;

        $scope.available_managers = $scope.tm_users;

        $scope.new_manager = {};

        // Materials.query({ 'trade': $scope.getTradeCode(item.name), 'get_suppliers': 1 }, function(items) {
        //     items.forEach(function(ii) {
        //         var inlist = $filter('filter')($scope.available_material_suppliers, {'name': ii.supplier}, true);

        //         if(inlist.length === 0) {
        //             $scope.available_material_suppliers.push({
        //                 name: ii.supplier
        //             });
        //         }
        //     });
        // });

        // Equipments.query({ 'trade': $scope.getTradeCode(item.name), 'get_suppliers': 1 }, function(items) {
        //     items.forEach(function(ii) {
        //         var inlist = $filter('filter')($scope.available_equipment_suppliers, {'name': ii.supplier}, true);

        //         if(inlist.length === 0) {
        //             $scope.available_equipment_suppliers.push({
        //                 name: ii.supplier
        //             });
        //         }
        //     });
        // });
    };

    $scope.acceptTradeEdits = function() {
        console.log(this);
        var trade = $filter('filter')(this.selectedItem.trades, {'name': $scope.current_selected_trade}, true);
        if(trade.length !== 1) {
            alert('Problem getting the trade ' + $scope.current_selected_trade + ' from the project info');
            return;
        }

        if(this.new_manager && this.new_manager.name) {
            trade[0].manager.email = this.new_manager.email;
            trade[0].manager.name = this.new_manager.name;
            trade[0].manager.phone = this.new_manager.phone;
            trade[0].manager.username = this.new_manager.username;

            $scope.selectedItem = this.selectedItem;
            $scope.new_manager = this.new_manager;

            //Find the scheduled tasks and update those as well. managers only
            this.selectedItem.lots.forEach(function(lot) {
                if(lot.scheduled) {
                    ProjectTasks.query({'project_id': 
                            $scope.selectedItem._id, 
                            'lot': lot.number, 
                            'phase': lot.phase,
                            'trade': $scope.user.trade[0]}, function(tasks) {
                        tasks.forEach(function(task) {
                            task.trade_manager_id = $scope.new_manager._id;
                            task.$update();
                        });
                    });
                }
            });
        }

        this.selectedItem.$update();
    };

    $scope.onPlanSelect = function(item) {
        $scope.current_plan = item;

        $scope.tasks = [];

        $scope.selectedItem.plan[0].task_list.forEach(function(task) {
            //This will get specific plan code based tasks. 
            //It will not get information for Standard
            var tmp_task = $filter('filter')($scope.bid_tasks, {'plan_code': $scope.current_plan.item, 'task_id': task.order}, true);
            var days = {};

            if(tmp_task.length > 0 && tmp_task[0].days) {
                days = tmp_task[0].days;
            }

            if(tmp_task.length === 1) {
                $scope.tasks.push({
                    name: task.name,
                    trade: task.trade,
                    task: task.task,
                    order: task.order,
                    days: days,
                    days_offset: task.days_offset,
                    hours_allowed: tmp_task[0].totals.hours_allowed,
                    bid_hours: tmp_task[0].totals.bid_hours,
                    plan_code: tmp_task[0].plan_code,
                    task_id: tmp_task[0].task_id
                });
            } else {
                //var plan = $filter('filter')($scope.selectedItem.plan, {'item': $scope.current_plan.item}, true)[0];
                var update = $filter('filter')($scope.selectedItem.plan[0].task_list, {'order': task.order}, true)[0];
                
                //customer wants table highlighting in the Standard plan view
                //for tasks that have hours_allowed.
                var tmp_task = $filter('filter')($scope.bid_tasks, {'task_id': task.order}, true);
                var hours = 0;
                if(tmp_task.length > 0) {
                    hours = tmp_task[0].totals.hours_allowed;
                }

                $scope.tasks.push({
                    name: update.name,
                    trade: update.trade,
                    task: update.task,
                    days: update.days,
                    days_offset: task.days_offset,
                    hours_allowed: hours,
                    order: update.order
                });
            }
        });
    };

    $scope.setEdit =  function(p) {
        $scope.editId = p._id;
        $scope.editLot = p.number;
        $scope.editPhase = p.phase;
        $scope.editPlan = p.plan;
        $scope.editStartDate = p.start_date;
        $scope.editOpened = false;
    };

    $scope.cancelEdit = function(lot) {
        $scope.editId = -1;
        lot.number = $scope.editLot;
        lot.phase = $scope.editPhase;
        lot.plan = $scope.editPlan;
        lot.start_date = $scope.editStartDate;
        $scope.editOpened = false;
    };

    $scope.saveLot = function(lot) {
        $scope.selectedItem.$update();
        $scope.editId = -1;
        $scope.editOpened = false;
    };

    $scope.editItem = function (item) {
        item.editing = true;
    };

    $scope.doneEditing = function (item) {
        if(!item.editing) return;

        var save = $filter('filter')($scope.selectedItem.plan[0].task_list, {'order': item.order}, true)[0];

        if(!save) {
            alert('Could not find editable task in list.  Contact Admin.');
            return;
        } 

        //days get updated to the main task list
        save.days = Number(item.days);

        //days get updated to the bid_tasks this change is associated with
        var tmp = $filter('filter')($scope.bid_tasks, {'task_id': item.order}, true);
        tmp.forEach(function(me) {
            me.days = save.days;
            me.$update();
        });
        
        $scope.selectedItem.$update();

        item.editing = false;
    };

    $scope.open = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        this.opened = true;
    };

    $scope.editOpen = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $timeout(function() {
            this.editOpened = true;
        }, 50);
    };

    $scope.datePickerSelected = function() {
        console.log('datepicker selected');
    };

    $scope.addLot = function() {
        console.log(this);
        if(this.selectedItem.lot_number && 
            this.selectedItem.plan_choice && this.selectedItem.start_date) {
            if(!this.selectedItem.group_option) this.selectedItem.group_option = '';
            this.selectedItem.lots.push({
                number: this.selectedItem.lot_number,
                phase: this.selectedItem.phase_number + $scope.selectedItem.group_option,
                plan: this.selectedItem.plan_choice.item,
                start_date: this.selectedItem.start_date
            });

            this.selectedItem.$update();

            this.selectedItem.lot_number =
            this.selectedItem.phase_number = 
            this.selectedItem.group_option =
            this.selectedItem.plan_choice = 
            this.selectedItem.start_date = '';
        } else {
            alert('please enter all fields');
        }
    };

    $scope.removeLot = function(lot) {
        $scope.resetLot(lot);
        
        var index = $scope.selectedItem.lots.indexOf(lot);
        $scope.selectedItem.lots.splice(index, 1);
        $scope.selectedItem.$update();     
    };

    $scope.updateProject = function() {
        this.selectedItem.$update();
    };

    $scope.registerApi = function(api) {
        $scope.api = api;

        api.core.on.ready($scope, function () {
            api.tasks.on.change($scope, onTaskChange);
        });
    }

    // Events
    var onTaskChange = function (selected) {
        // console.log('new diff time: ' + moment.duration(selected.model.to.diff(selected.model.from)).asDays());
        // console.log('new from time: ' + selected.model.from.get().format('DDD'));

        var task = $filter('filter')($scope.selectedItem.plan[0].task_list, {'order': selected.model.data.order}, true)[0];

        if(!task) {
            alert('Problem getting the task for changing.  Contact Admin.');

            return;
        }

        task.days = Number(moment.duration(selected.model.to.diff(selected.model.from)).asDays());
        //console.log(selected.model.from);
        task.days_offset = Number(selected.model.from.format('DDD')) - 1;

        $scope.selectedItem.$update();

        var tasks = $filter('filter')($scope.bid_tasks, {'task_id': selected.model.data.order}, true);
        tasks.forEach(function(task) {
            task.days = Number(moment.duration(selected.model.to.diff(selected.model.from)).asDays());
            task.days_offset = Number(selected.model.from.format('DDD')) - 1;
            task.$update();
        });

        $scope.onPlanSelect($scope.current_plan);
    };

    $scope.timeFrames = {
        day: {
            start: moment('00:00', 'HH:mm'),
            end: moment('23:59', 'HH:mm'),
            working: true, // This is a working period
            default: true // It will be used for each day
        },
        noon: {
            start: moment('12:00', 'HH:mm'),
            end: moment('13:30', 'HH:mm'),
            magnet: false, // This will disable magnet snapping
            working: false, // This is a resting period
            default: true // It will be used for each day
        },
        closed: {
            magnet: false, // This will disable magnet snapping
            working: false // We don't work when it's closed
        }
    };

    $scope.dateFrames = {
        halloween:{
            date: moment('2015-01-31', 'YYYY-MM-DD'), // A specific date
            targets: ['day'] // Use timeFrame named day for halloween. We won't close for noon.
        },
        holidays: {
            start: moment('2015-02-15', 'YYYY-MM-DD'), // A date range
            end: moment('2014-02-30', 'YYYY-MM-DD'),
            targets: ['closed'] // use timeFrame named closed for this date range.
        }, 
        weekend: {
            evaluator: function(date) { // A custom function evaluated for each day in the gantt
            return date.isoWeekday() === 6 || date.isoWeekday() === 7;
        },
        targets: ['closed'] // Use timeFrame named closed for saturday and sunday.
        }
    };

    $scope.getColumnWidth = function(widthEnabled, scale, zoom) {
        if (!widthEnabled && $scope.canAutoWidth(scale)) {
            return undefined;
        }

        if (scale.match(/.*?week.*?/)) {
            return 150 * zoom;
        }

        if (scale.match(/.*?month.*?/)) {
            return 300 * zoom;
        }

        if (scale.match(/.*?quarter.*?/)) {
            return 500 * zoom;
        }

        if (scale.match(/.*?year.*?/)) {
            return 800 * zoom;
        }

        return 40 * zoom;
    };

    $scope.checkLots = function() {
        $scope.selectedItem.lots.forEach(function(lot) {
            console.log('lot ' + lot.number + ' scheduled value: ' + lot.scheduled);
        });
    };

    $scope.resetLot = function(lot) {
        lot.scheduled = false;
        ProjectTasks.query({'project_id': $scope.selectedItem._id, 'lot': lot.number, 'phase': lot.phase}, function(tasks) {
            tasks.forEach(function(task) {
                task.$delete();
            });
        });
        $scope.selectedItem.$update();
    };

    $scope.padDigits = function(number, digits) {
        return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
    }

    $scope.scheduleLot = function(lot) {
        if(!$scope.selectedItem.contact.timezone) {
            alert('You must specify a timezone in the Edit Projects tab  in the format -0600');
            return;
        }
        console.log('Need to schedule lot ' + lot.number + ' with start date: ' + moment(lot.start_date).format('YYYY-MM-DD'));
        //var tasks = $filter('filter')($scope.bid_tasks, {'plan_code': lot.plan}, true);
        //var ordered_tasks = $filter('orderBy')(tasks, 'days_offset', false);
        var ordered_tasks = $filter('orderBy')($scope.selectedItem.plan[0].task_list, 'days_offset', false);

        var current_day = moment(lot.start_date);
        var day_count = 0;
        var off_days = 0;
        var day_incrementor = 0;
        var task_incrementor = 0;
        var starting_job_code = 1;
        var not_done = true;

        current_day.hour(7);
        current_day.minute(0);
        current_day.second(0);

        //this is really ugly but it's the best i got.  because the schedule section
        //only gives me days_offset from the start date, I have to go through and 
        //figure out which days are holidays or weekends.  And because a project
        //does not track all tasks but only tasks assign via the trade, I can't just
        //iterate over the ordered_tasks.  
        for(var i=0; i<550 && not_done; i++) {
            //is today a holiday or weekend
            if($scope.disabled(new Date(current_day), 'day')) off_days += 1;

            day_count = day_incrementor - off_days;

            ordered_tasks[task_incrementor].task_code =
                ordered_tasks[task_incrementor].trade + ordered_tasks[task_incrementor].task;

            if(day_count === ordered_tasks[task_incrementor].days_offset) {
                //get the actual trade manager from the project for the particular trade
                var manager;
                if(tradeCodeService.getName(ordered_tasks[task_incrementor].trade)) {
                    manager = $filter('filter')($scope.selectedItem.trades, {
                        'name': tradeCodeService.getName(ordered_tasks[task_incrementor].trade)})[0];
                }

                var tm = {};

                if(manager) {
                    //get the system specific trade manager so we can pass the id
                    tm = manager.manager;
                } else {
                    //if there is no manager then that means
                    //it is not a system task so set the manager
                    //to the MTC user id
                    tm = $scope.user;
                }

                var bid_t = $filter('filter')($scope.bid_tasks,{
                    'task_code': ordered_tasks[task_incrementor].task_code, 'plan_code': lot.plan}, true)

                if(bid_t.length === 0) {
                    bid_t.push({
                        '_id': 0
                    });
                }
                //console.log('Schedule ' + ordered_tasks[task_incrementor].task_code + ' on date: ' +
                //    current_day.format('YYYY-MM-DD') + ' with offset: ' + ordered_tasks[task_incrementor].days_offset);

                //create the end date and set the timezone
                var end_date = moment(current_day);
                end_date.add(ordered_tasks[task_incrementor].days - 1, 'days');
                end_date.hour(15);
                end_date.minute(30);
                var bid_hours = 0;

                if(bid_t[0]._id !== 0) {
                    console.log('Setting labor hours ' + bid_t[0].totals.hours_allowed);
                    bid_hours = bid_t[0].totals.hours_allowed
                }

                var formatString = 'yyyy-MM-ddTHH:mm' + $scope.selectedItem.contact.timezone;
                //console.log('Using formatString value: ' + formatString);
                var new_task = new ProjectTasks({
                    task_name: ordered_tasks[task_incrementor].name,
                    trade: tradeCodeService.getName(ordered_tasks[task_incrementor].trade),
                    trade_manager_id: tm._id,
                    project_id: $scope.selectedItem._id,
                    //project_bid_id: (bid_t[0]._id !== 0)? ,
                    task_code: ordered_tasks[task_incrementor].task_code,
                    plan_code: lot.plan,
                    start_date: $filter('date')(new Date(current_day), formatString),
                    end_date: $filter('date')(new Date(end_date), formatString),
                    lot: lot.number,
                    days: ordered_tasks[task_incrementor].days,
                    days_offset: ordered_tasks[task_incrementor].days_offset,
                    timezone: $scope.selectedItem.contact.timezone,
                    contractor_code: $scope.selectedItem.company_code,
                    division_code: $scope.selectedItem.trade_code,
                    division: {
                        name: $scope.selectedItem.name,
                        address_one: $scope.selectedItem.contact.address_one,
                        address_two: $scope.selectedItem.contact.address_two,
                        city: $scope.selectedItem.contact.city,
                        state: $scope.selectedItem.contact.state,
                        zip: $scope.selectedItem.contact.zip
                    },
                    job_code: $scope.selectedItem.job_code,
                    phase: lot.phase,
                    status: 'on_track',
                    hot_sheet: false,
                    bid_hours: bid_hours,
                    actual_man_hours: 0,
                    actual_labor_costs: 0,
                    actual_material_costs: 0,
                    actual_equipment_costs: 0,
                    notes: {
                        date: new Date(),
                        comment: 'Task created',
                        username: $scope.user.username
                    }
                });

                if(bid_t[0]._id)
                  new_task.project_bid_id = bid_t[0]._id;

                new_task.$save();

                starting_job_code  += 1;
                task_incrementor += 1;
            } else {
                if(ordered_tasks[task_incrementor].trade === '13')
                    console.log('Painting task is not getting scheduled');
            }

            //if there are no more tasks to schedule, then just move along.
            if(!ordered_tasks[task_incrementor]) {
                console.log('We\'re done with task scheduling');
                not_done = false;
                break;
            }

            //need to check the next task in the list to make sure it
            //is not scheduled on the same day.
            if(day_count !== ordered_tasks[task_incrementor].days_offset) {
                day_incrementor += 1;
                current_day.add(1, 'day');
            }
        }

        lot.scheduled = true;
        $scope.selectedItem.$update();
    };

    $scope.scheduleAllLots = function() {
        $scope.selectedItem.lots.forEach(function(lot) {
            if(!lot.scheduled) {
                $scope.scheduleLot(lot);
            }
        });
    };

    // $scope.copyNotes = function() {
    //     console.log('copy function... ' + $scope.selectedItem);
    //     Bids.query({'bid_status': 'project'}, function(bid) {
    //         console.log('bids returned... ' + bid);
    //     });
    // };
    $scope.getTradeCode = function(trade) {
        return tradeCodeService.getCode(trade);
    };
 
    $scope.getTradeString = function(trade) {
        return tradeCodeService.getName(trade);
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/projects/public/controllers/projectAdminEdit.js